var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M320 343.281C320 418.656 258.658 480 183.27 480H104.664C57.853 480 16.448 450.156 1.651 405.75C-3.942 388.969 5.136 370.844 21.901 365.25C38.681 359.75 56.775 368.75 62.368 385.5C68.446 403.75 85.445 416 104.664 416H183.27C223.378 416 256.002 383.375 256.002 343.281C256.002 303.156 223.378 270.531 183.27 270.531H32.01C22.51 270.531 13.51 266.313 7.432 259.031C1.355 251.719 -1.177 242.094 0.542 232.75L32.541 58.219C35.322 43.031 48.556 32 64.009 32H256.002C273.673 32 288.001 46.312 288.001 64S273.673 96 256.002 96H90.68L70.415 206.531H183.27C258.658 206.531 320 267.875 320 343.281Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.6f658b1aaf19554278e59fd228357577.svg";
export { ForwardRef as ReactComponent };